<template>
  <div class="no-access-page">
    <div class="no-access-content">
      <!-- 插图区域：保持原始比例，避免拉伸模糊 -->
      <div class="no-access-visual">
        <img
          class="no-access-img"
          src="@/assets/img/Noaccess.png"
          alt="无权限访问"
        />
      </div>
      <!-- 辅助说明文案 -->
      <p class="no-access-title">无权限访问</p>
      <p class="no-access-desc">请通过智为云登录访问该页面</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoAccess",
  mounted() {
    // 进入无权访问页后拦截浏览器后退，避免返回到无 token 的业务页
    this.preventBrowserBack();
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.handlePopState);
  },
  methods: {
    // 通过 pushState + popstate 监听，阻止用户通过浏览器后退离开当前页
    preventBrowserBack() {
      history.pushState(null, "", location.href);
      this.handlePopState = () => {
        history.pushState(null, "", location.href);
      };
      window.addEventListener("popstate", this.handlePopState);
    },
  },
};
</script>

<style lang="scss" scoped>
.no-access-page {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: auto;
  // 与项目主容器背景色保持一致
  background: linear-gradient(180deg, #f7fafc 0%, #eef2f6 100%);
}

.no-access-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 520px;
  width: 100%;
}

.no-access-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 32px 24px;
  border-radius: 12px;
  background: #1a1a1a;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
}

.no-access-img {
  display: block;
  width: 280px;
  max-width: 100%;
  height: auto;
  // 保持图片清晰，禁止拉伸变形
  object-fit: contain;
}

.no-access-title {
  margin: 28px 0 8px;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.no-access-desc {
  margin: 0;
  font-size: 14px;
  color: #909399;
  line-height: 1.6;
}
</style>
